import { useState, useEffect } from "react";
import { translate } from "@locales";
import OutlinedButton from "@components/atoms/base-button/OutlinedButton";

type Email = {
  input: boolean;
};


export function EmailInput({ input }: Email) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    if (status === "success") {
      const timer = setTimeout(() => {
        setStatus("idle");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [status]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      setStatus("error");
      setErrorMessage("Email is required");
      return;
    }

    setStatus("loading");
    setErrorMessage("");

    try {
      const suscribe = await fetch("/api/klaviyo/newsletter-suscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (suscribe.status === 202) {
        setStatus("success");
        setEmail("");
      } else {
        throw new Error("Subscription failed");
      }
    } catch (error) {
      setStatus("error");
      setErrorMessage(
        error instanceof Error ? error.message : "An unexpected error occurred"
      );
    }
  };

  if (!input) return null;

  return (
    <form onSubmit={handleSubmit} className="relative">
      <div>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full mb-3 md:w-[300px] h-[45px] border-white border text-white text-base placeholder-white bg-transparent px-4"
          placeholder={translate("bannerBottom.general-banner.placeHolder")}
          required
          title="Please enter a valid email address"
        />

        <OutlinedButton
          type="submit"
          className="w-full md:w-wide178 border-none text-black font-chivo-regular uppercase tracking-[1.3px]"
          disabled={status === "loading"}
        >
          {status === "loading"
            ? "Subscribing..."
            : translate("bannerBottom.general-banner.button")}
        </OutlinedButton>

        {status === "success" && (
          <p className="text-green-500 mt-2">Successfully subscribed!</p>
        )}

        {status === "error" && (
          <p className="text-red-500 mt-2">
            {errorMessage || "Subscription failed. Please try again."}
          </p>
        )}
      </div>
    </form>
  );
}

